import React, { useEffect, useState } from "react";
import { Grid, Header, Button } from "semantic-ui-react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { AgGridReact } from "ag-grid-react";
import "ag-grid-community/styles/ag-grid.css";
import "ag-grid-community/styles/ag-theme-alpine.css";
import { AiFillEdit, AiFillDelete } from "react-icons/ai";
import { BaseUrl } from "../formcomponents/Constants";
import { compose } from "@reduxjs/toolkit";
import * as FileSaver from "file-saver";
import * as XLSX from "xlsx";
import Swal from "sweetalert2";
import { userData } from "../store/userData";
const ListCompanyWithCat = (props) => {
  const { categoryId } = props;
  const navigate = useNavigate();
  const userDetail = userData();
  useEffect(() => {
    getCompanyList();
  }, []);
  const [excelData, setexcelData] = useState([]);
  const [rowData, setrowData] = useState([]);
  const getCompanyList = () => {
    const postObject = {
      categoryId: categoryId,
      getAll: categoryId == 0 ? true : false,
    };
    axios
      .post(BaseUrl + "listSSCompany", postObject)
      .then((res) => {
        console.log("res", res.data);
        setrowData(res.data);
        setDataForExcel(res.data);
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const setDataForExcel = (record) => {
    const tempRecord = record.map(
      ({
        companyNameAndPartners,
        partnersName,
        contactNumber,
        emailId,
        licenseNum,
        expiryDate,
        establismentCard,
        estCardExpiryDate,
        status,
        remarks,
      }) => ({
        "Company Name": companyNameAndPartners,
        "Partner Name": partnersName,
        Contact: contactNumber,
        Email: emailId,
        "License Number": licenseNum,
        "Expiry Daye": expiryDate,
        "Establisment Card": establismentCard,
        "EstCardExpiry Date": estCardExpiryDate,
        Status: status,
        Remarks: remarks,
      })
    );
    setexcelData(tempRecord);
  };
  const columnDefs = [
    { headerName: "Company Name", field: "companyNameAndPartners" },
    { headerName: "Partner Name", field: "partnersName" },

    { headerName: "Contact", field: "contactNumber" },
    { headerName: "Email", field: "emailId" },
    { headerName: "License Num", field: "licenseNum" },
    { headerName: "Expiry Date", field: "expiryDate" },

    { headerName: "Establisment Card", field: "establismentCard" },
    { headerName: "EstCardExpiry Date", field: "estCardExpiryDate" },
    { headerName: "Status", field: "status" },
    { headerName: "Remarks", field: "remarks" },
    // { headerName: "estCardExpiryDate", field: "estCardExpiryDate" },

    {
      headerName: "Edit/Delete",
      filter: false,
      field: "companyId",
      cellRendererFramework: (params) => (
        <div>
          <Button color="primary" onClick={() => updateRecord(params)}>
            <AiFillEdit />
          </Button>
          <Button color="red" onClick={() => deleteRecord(params)}>
            <AiFillDelete />
          </Button>
        </div>
      ),
    },
  ];

  const deleteRecord = (params) => {
    ///deleteCompany
    Swal.fire({
      title: "Are you sure?",
      text: "You won't be able to revert this!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, delete it!",
    }).then((result) => {
      if (result.isConfirmed) {
        axios
          .post(BaseUrl + "deleteSSCompany", {
            companyListId: params.data.companyListId,
          })
          .then((res) => {
            console.log("res", res.data);
            Swal.fire(
              "Deleted!",
              "Company Recored has been deleted.",
              "success"
            );
          })
          .catch((error) => {
            console.log(error);
          });
      }
    });
  };

  const updateRecord = (params) => {
    // console.log("Params", params.data.companyListId);
    navigate(
      `/create-company-newFormet/${params.data.companyListId}/${categoryId}`
    );
  };
  const defaultColDef = {
    sortable: true,
    editable: true,
    flex: 1,
    filter: true,
    floatingFilter: true,
  };

  const fileType =
    "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";
  const fileExtension = ".xlsx";

  const exportToCSV = (csvData, fileName) => {
    const ws = XLSX.utils.json_to_sheet(csvData);
    const wb = { Sheets: { data: ws }, SheetNames: ["data"] };
    const excelBuffer = XLSX.write(wb, { bookType: "xlsx", type: "array" });
    const data = new Blob([excelBuffer], { type: fileType });
    FileSaver.saveAs(data, fileName + fileExtension);
  };
  return (
    <div>
      <Grid.Row>
        <Header dividing size="huge" as="h1">
          Company List
        </Header>
      </Grid.Row>
      <br />
      <Grid.Row>
        {categoryId != 0 && (
          <Button
            color="primary"
            onClick={() =>
              navigate(`/create-company-newFormet/null/${categoryId}`)
            }
          >
            Create New
          </Button>
        )}

        <Button
          color="primary"
          onClick={(e) => exportToCSV(excelData, "Company_List")}
        >
          Export Excel
        </Button>
      </Grid.Row>
      <br />
      <Grid.Row>
        <div className="ag-theme-alpine" style={{ height: 600 }}>
          <AgGridReact
            rowData={rowData}
            columnDefs={columnDefs}
            defaultColDef={defaultColDef}
            pagination={true}
          ></AgGridReact>
        </div>
      </Grid.Row>
    </div>
  );
};

export default ListCompanyWithCat;
